import ModelProperty from "./modelProperty";

export default class FileProperty extends ModelProperty {
  file_display_limit: number;

  constructor() {
    super();
    this.defineProperty('file_display_limit', 5);
  }

  get defaultLabel(): string {
    return "File Attachments";
  }

  get isModelProperty(): boolean {
    return false
  }
}